import { Donvi } from './donvi';
import { Thongtinluuychitiet } from './thongtinluuychitiet';

export class Thongtinluuy {
    id: number;
    tieude: String;
    isactive: number;
    createddate: Date;
    createdbyuserid: number;
    modifiedbyuserid: number;
    modifieddate: Date;
    iddonvi: number;
    dmDonvi: Donvi;
    chitiets: Thongtinluuychitiet[];
}